<form [formGroup]="fgPassword">
  <div class="modal-header">
    <h4 *ngIf="userAction === 'Activate'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Activate User</h4>
    <h4 *ngIf="userAction === 'Deactivate'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Deactivate User</h4>
    <h4 *ngIf="userAction === 'Suspend'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Suspend User</h4>
    <h4 *ngIf="userAction === 'Delete'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Delete User</h4>
    <h4 *ngIf="userAction === 'Reset Password'" class="modal-title">
      <i class="fa fa-warning neo-warning">
      </i>&nbsp; {{user.status === 'Pending user action' ? 'Resend Password Email' : 'Reset Password'}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="(userAction === 'Activate') && user.deactivationDate">
      <h6>Are you sure you want to reactivate {{user.firstName}} {{user.lastName}}?</h6>
      <p>This will remove deactivation date {{ user.deactivationDate.toISOString().split('T')[0] }} for the user </p>
      <p>Once reactivated, you can change the deactivation date for the user later.</p>
    </div>
    <div *ngIf="userAction === 'Deactivate'">
      <!-- Check if physician/NPPA user has facility assignments and doesn't use MatrixCare -->
      <ng-container *ngIf="shouldBlockDeactivation; else normalDeactivation">
        <p>You must unassign a Physician or NP/PA from all MatrixCare 360 facilities before deactivating. You will be unable to deactivate the account if the provider is assigned to inactive resident Face Sheets.</p>
      </ng-container>

      <!-- Normal deactivation message -->
      <ng-template #normalDeactivation>
        <h6>Are you sure you want to deactivate {{user.firstName}} {{user.lastName}}?</h6>
        <p>This will remove access rights and permissions for the user to all applications.</p>
        <p>Once deactivated, you can activate or delete the user later.</p>
      </ng-template>
    </div>
    <div *ngIf="userAction === 'Suspend'">
      <h6>Are you sure you want to suspend {{user.firstName}} {{user.lastName}}?</h6>
      <p>This will temporarily restrict users access to their applications.</p>
      <p>Once suspended you can activate the user later.</p>
    </div>
    <div *ngIf="userAction === 'Delete'">
      <h6>Are you sure you want to delete {{user.firstName}} {{user.lastName}}?</h6>
      <p>This will permanently delete the user, this action cannot be undone.</p>
    </div>
    <div *ngIf="userAction === 'Reset Password'">
      <div *ngIf="null === temporaryPassword">
        <h6>Are you sure you want to reset {{user.firstName}} {{user.lastName}}&apos;s password?</h6>
        <p *ngIf="user.email">
          A <strong>Reset Password Link </strong> is sent to this user's primary email address; the password is not automatically reset.
          The password
          reset link will expire 1 day after it is sent.
        </p>
        <p *ngIf="(user.status !== 'Pending user action')">
          A <strong>Temporary Password</strong> will be created for the account and shown to you.
          The account will be marked as expired so that
          the user will be required to change the password when they login.
        </p>
      </div>

      <div *ngIf="null !== temporaryPassword">
        <h6>Temporary Password</h6>
        <p>Temporary password is a one-time password. User account will be marked as expired.</p>
        <p>
          The temporary account password is:
          <input type="text" formControlName="passwordCtl" [(ngModel)]="temporaryPassword" [ngbPopover]="popContent" popoverTitle="Password Requirements" placement="right" />
          <button (click)="copyAction(temporaryPassword)"><i class="fa fa-copy"></i></button>
          <small *ngIf="!fgPassword.valid" class="text-danger">Please enter new user’s temporary password with rules.</small>
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <!--             TODO: Move this code to controller to respond the buttons conditionally based on the actions. -->
    <button type="submit" *ngIf="userAction === 'Reset Password' && null === temporaryPassword && user.email" class="btn btn-primary"
            (click)="submitModal(userAction)">
      Reset Password Link
    </button>
    <button type="submit" *ngIf="userAction === 'Reset Password' &&  null === temporaryPassword && user.status !== 'Pending user action'"
            class="btn btn-primary" (click)="submitModal('ExpirePassword')">
      Temporary Password
    </button>
    <button type="submit" *ngIf="userAction != 'Reset Password' && !(userAction === 'Deactivate' && shouldBlockDeactivation)" [ngClass]="userAction == 'Activate' ? 'btn btn-primary' : 'btn btn-danger'" (click)="submitModal(userAction)" [re-disable-when-clicked]>{{userAction}}</button>

    <button type="button" *ngIf="userAction === 'Deactivate' && shouldBlockDeactivation" class="btn btn-primary" (click)="activeModal.close('OK click')">OK</button>

    <button type="button" [disabled]="!fgPassword.valid" *ngIf="userAction === 'Reset Password' && null !== temporaryPassword" [ngClass]="'btn btn-primary'" (click)="temporaryPasswordAction(temporaryPassword)">OK</button>
    <button type="button" *ngIf="temporaryPassword === null && !(userAction === 'Deactivate' && shouldBlockDeactivation)" [ngClass]="'btn btn-cancel'" (click)="activeModal.close('Cancel click');temporaryPassword=null">Cancel</button>

  </div>

</form>
<ng-template #popContent>
  <re-password-requirements [password]="temporaryPassword"
                            [username]="user?.userName"
                            [firstName]="user?.firstName"
                            [lastName]="user?.lastName">
  </re-password-requirements>
</ng-template>
